<template>
  <img :src="`/images/icons/${name}.svg`" class="icon" />
</template>
<script>
export default {
  props: ['name']
}
</script>
<style scoped>
.icon {
  width: 16px;
  height: 16px;
}
</style>
